import React, { Fragment } from 'react';
import lodash from 'lodash';
import { SignatureStatus } from './SignatureStatus';
import styles from './Slat.scss';

import moment from 'moment';

export function EventSlat(event, onClick){
    const {
        id: eventId,
        eventType: {
            displayName,
            slatFields,
        },
        primaryDate,
        fields,
        signatureRequestStatus,
    } = event;
    const slatTitle = displayName;
    const slatSubTitleComponent =
          <SignatureStatus total={signatureRequestStatus.total} pending={signatureRequestStatus.pending} canceled={signatureRequestStatus.canceled}/>;

    const slatDetails = extractFieldsToDisplayInSlat(slatFields, fields);
    const primaryDateDetail = extractPrimaryDateDetail(primaryDate);
    const details = lodash.flatten([primaryDateDetail, slatDetails]);

    return <Slat key={eventId} title={slatTitle} subtitleComponent={slatSubTitleComponent} details={details} onClick={onClick} />;
}

function Slat({
    title = '',
    subtitleComponent = null,
    details = [],
    onClick,
}){
    return (
        <li className={styles.slatItem} onClick={onClick} data-cy="Slat">
            <div className={styles.slatInner} data-cy="Slat-div">
                <SlatHead>
                    <p className={styles.slatTitle} data-cy="Slat-title">{title}</p>
                    {subtitleComponent}
                </SlatHead>
                <SlatBody>
                    {details.map(detail =>
                        <TitleValueDetail key={detail.title} title={detail.title} value={detail.value}/>)}
                </SlatBody>
            </div>
        </li>
    );
}

function SlatHead(props){
    return (
        <div className={styles.slatEntry} data-cy="Slat-SlatHead">
            {props.children}
        </div>
    );
}

function SlatBody({children}){
    return (
        <Fragment>
            {children}
        </Fragment>
    );
}

function TitleValueDetail({ title, value }){
    return (
        <div className={styles.slatEntry} data-cy="Slat-TitleValueDetail">
            <p className={styles.slatEntryTitle} data-cy="Slat-title">{title}</p>
            <p className={styles.slatEntryValue} data-cy="Slat-value">{value}</p>
        </div>
    );
}

function extractPrimaryDateDetail({ displayName='', value='' }) {
    let dateDetail;
    if (value) {
        dateDetail = moment.utc(value).format('MM/DD/YYYY');
    } else {
        dateDetail = 'Not specified';
    }

    return {
        title: displayName,
        value: dateDetail,
    };
}

function extractFieldsToDisplayInSlat(slatFields = [], fields = []) {
    const fieldsToDisplay = slatFields.map(slatField => {
        const eventField = fields.find(field => field.id === slatField);

        let value;
        if (!eventField.value) {
            value = 'Not specified';
        } else if (eventField.valueType === 'Date') {
            const dateFormat = moment.utc(eventField.value).format('LL').replace(',', '');
            value = dateFormat;
        } else {
            value = eventField.value;
        }

        const slatFieldData = {
            title: eventField.displayName,
            value: value,
        };

        return slatFieldData;
    });

    return fieldsToDisplay;
}
